import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5244417c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "palette-wrap" }
const _hoisted_2 = ["onClick"]


const __default__ = {
  name: 'Palette'
}

import Color from 'color'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['update:color'],
  setup(__props, { emit }) {


const palettes: string[][] = [
  // 第一行
  [
    '#fcc02eff',
    '#f67c01ff',
    '#e64a19ff',
    '#d81b43ff',
    '#8e24aaff',
    '#512da7ff',
    '#1f87e8ff',
    '#008781ff',
    '#05a045ff'
  ],
  // 第二行
  [
    '#fed835ff',
    '#fb8c00ff',
    '#f5511eff',
    '#eb1d4eff',
    '#9c28b1ff',
    '#5d35b0ff',
    '#2097f3ff',
    '#029688ff',
    '#4cb050ff'
  ],
  // 第三行
  [
    '#ffeb3cff',
    '#ffa727ff',
    '#fe5722ff',
    '#eb4165ff',
    '#aa47bcff',
    '#673bb7ff',
    '#42a5f6ff',
    '#26a59aff',
    '#83c683ff'
  ],
  // 第四行
  [
    '#fff176ff',
    '#ffb74eff',
    '#ff8a66ff',
    '#f1627eff',
    '#b968c7ff',
    '#7986ccff',
    '#64b5f6ff',
    '#80cbc4ff',
    '#a5d6a7ff'
  ],
  // 第五行
  [
    '#fff59cff',
    '#ffcc80ff',
    '#ffab91ff',
    '#fb879eff',
    '#cf93d9ff',
    '#9ea8dbff',
    '#90caf8ff',
    '#b2dfdcff',
    '#c8e6caff'
  ],
  // 最后一行
  [
    '#ffffffff',
    '#dededeff',
    '#a9a9a9ff',
    '#4b4b4bff',
    '#353535ff',
    '#212121ff',
    '#000000ff'
  ]
]

const onColorChange = (color: string) => {
  const commonColor = Color(color)
  emit('update:color', commonColor.hexa(), 1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(palettes, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (item1, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "palette-row__color-cube--wrap",
            onClick: ($event: any) => (onColorChange(item1))
          }, [
            _createElementVNode("div", {
              class: "palette-row__color_cube",
              style: _normalizeStyle({ background: item1 })
            }, null, 4)
          ], 8, _hoisted_2))
        }), 128))
      ], 64))
    }), 64))
  ]))
}
}

})